import React from "react";
import { Typography, Box} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

function PageAppBar3() {
    return (
        <Box style={{backgroundColor: 'transparent', width: '320px'}}>
            <AccessTimeIcon sx={{float:"left", marginTop:"12px", marginRight:"10px", color:"#ffea00"}} />
            <Typography style={{color: "white", fontSize:"13px"}} component="div">
                HORÁRIO DE FUNCIONAMENTO
                </Typography>
                <Typography mt={1} style={{color: "#9e9e9e", fontStyle: "bold"}} variant="subtitle2" color="text.secondary">
                SEG à SEX: 06:00 às 11:00 - 16:00 às 21:00
            </Typography>
        </Box>
    );
};
export default PageAppBar3;